var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7444_13592)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M16.3843 12.867L9.0222 16.2152L16.3843 20.5648L23.7436 16.2152L16.3843 12.867Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M9.0222 16.2152L16.3843 20.5648V4L9.0222 16.2152Z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.3843 4V20.5648L23.7436 16.2152L16.3843 4Z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M9.0222 17.6101L16.3843 27.9819V21.9596L9.0222 17.6101Z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.3843 21.9596V27.9819L23.7493 17.6101L16.3843 21.9596Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7444_13592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7658,
    height: 24,
    transform: "translate(9 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.03c58e04b2d05899116775550fa23452.svg";
export { ForwardRef as ReactComponent };